import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { activateEdit } from "../../features/job/jobSlice";
import { removeJob } from "../../features/jobs/jobsSlice";

export default function JobItem ({job}) {
    const dispatch = useDispatch();
    const navidate = useNavigate();

    const { id, title, type, salary, deadline } = job || {};

    
    let typeWiseColor = '';
    if (type === 'Internship') typeWiseColor = '#FF5757';
    else if (type === 'Full Time') typeWiseColor = '#FF8A00';
    else if (type === 'Remote') typeWiseColor = '#56E5C4';
    
    const handleEdit = () => {
        dispatch(activateEdit(job));
        navidate(`editjob/${id}`);
    }

    const handleDelete = () => {
        dispatch(removeJob(id));
    }

    return (
        <div className="job">
            <div className="flex-1 min-w-0">
                <h2 className="lws-title">{title}</h2>
                <div className="job-footers">
                    <div className="lws-type">
                        <i className={`fa-solid fa-stop !text-[${typeWiseColor}] text-lg mr-1.5`}></i>
                        {type}
                    </div>
                    <div className="lws-salary">
                        <i className="fa-solid fa-bangladeshi-taka-sign text-slate-400 text-lg mr-1.5"></i>
                        BDT {salary}
                    </div>
                    <div className="lws-deadline">
                        <i className="fa-regular fa-calendar text-slate-400 text-lg mr-1.5"></i>
                        Closing on {deadline}
                    </div>
                </div>
            </div>
            <div className="mt-5 flex lg:mt-0 lg:ml-4">
                <span className="hidden sm:block">
                    <button 
                        onClick={handleEdit}
                        type="button"
                        className="lws-edit btn btn-primary"
                    >
                        <i className="fa-solid fa-pen text-gray-300 -ml-1 mr-2"></i>
                        Edit
                    </button>
                </span>

                <span className="sm:ml-3">
                    <button
                        onClick={handleDelete}
                        type="button"
                        className="lws-delete btn btn-danger "
                    >
                        <i className="fa-solid fa-trash text-gray-300 -ml-1 mr-2"></i>
                        Delete
                    </button>
                </span>
            </div>
        </div>
    );
}